var render = function render(){var _vm=this,_c=_vm._self._c;return _c('easyscreen-button',{class:[
    'easyscreen-circle-button',
    `easyscreen-circle-button_${ _vm.size }`,
    `easyscreen-circle-button_label-${ _vm.labelPlacement }`,
    `easyscreen-circle-button_label-${ _vm.labelSize || _vm.size }`
  ],attrs:{"size":"small","color":_vm.color,"custom-color":_vm.customColor,"custom-active-color":_vm.customActiveColor}},[(_vm.iconType === 'font-icon')?_c('i',{class:['easyscreen-circle-button--icon', _vm.icon]}):_vm._e(),(_vm.iconType === 'image')?_c('img',{staticClass:"easyscreen-circle-button--icon",attrs:{"src":_vm.icon}}):_vm._e(),_c('span',{staticClass:"easyscreen-circle-button--text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }